import { Theme, WithStyles, withStyles } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import createStyles from "@material-ui/core/styles/createStyles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { inject, observer } from "mobx-react";
import React from "react";
import { CommonsStore } from "../../../model/CommonsStore";
import { expandedTextStyles } from "./NestedListWrapper";

const styles = (theme: Theme) =>
  createStyles({
    expandedText: expandedTextStyles(theme) as any,
    icon: {
      height: 20,
      width: 20,
      boxSizing: "border-box",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 20,
      paddingRight: -6,
      margin: "-5px 15px"
    },
    expandedList: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderLeft: "0",
      borderRadius: "0 3px 3px 0",
      boxShadow: "2px 1px 3px rgba(0,0,0,0.1)",
      boxSizing: "border-box",
      color: "black",
      display: "block",
      left: "70px",
      width: "265px",
      marginTop: 24,
      padding: "0px",
      position: "fixed"
    },
    listIcon: {
      paddingLeft: "6px"
    },
    listElement: {
      "&:hover": {
        height: "48px"
      }
    }
  });

interface NestedListWhenDrawerCollapsedProps extends WithStyles<typeof styles> {
  commons?: CommonsStore;
  collapse: () => void;
  expand: () => void;
  Icon?: any;
  isTextExpanded: boolean;
  open: boolean;
  text: string;
  toggleNestedListOpen: () => void;
}

const NestedListWhenDrawerCollapsedComponent: React.SFC<NestedListWhenDrawerCollapsedProps> = inject(
  "commons"
)(
  observer(props => {
    const {
      children,
      classes,
      collapse,
      expand,
      Icon,
      isTextExpanded,
      open,
      text,
      toggleNestedListOpen
    } = props;

    return (
      <ListItem
        key="header"
        button={true}
        onMouseEnter={expand}
        onMouseLeave={collapse}
        className={classes.listElement}
      >
        <ListItemIcon
          className={classes.listIcon}
          onClick={toggleNestedListOpen}
        >
          <Icon />
        </ListItemIcon>
        <ListItemText
          className={isTextExpanded ? classes.expandedText : undefined}
          onClick={toggleNestedListOpen}
        >
          {text}
          {open ? (
            <ExpandLess className={classes.icon} />
          ) : (
            <ExpandMore className={classes.icon} />
          )}
        </ListItemText>
        <Collapse
          key="body"
          in={open && isTextExpanded}
          timeout={0}
          unmountOnExit={true}
        >
          <List className={classes.expandedList}>{children}</List>
        </Collapse>
      </ListItem>
    );
  })
);

export const NestedListWhenDrawerCollapsed = withStyles(styles)(
  NestedListWhenDrawerCollapsedComponent
);
